export const utils =
{
    base64toBlob,
    formatDate,
    formatDateTime,
    toLocalNetString,
    generateUuid,
    toArray,
    toNewArray,
    intToStringWithPadZero,
    intToStringWithPadZeroHex
}

function formatDateTime(date) {
    const stringDate = ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        date.getFullYear() +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2) + ":" +
        ("0" + date.getSeconds()).slice(-2);
    return stringDate;
}

function formatDate(date) {
    const stringDate = ("0" + date.getDate()).slice(-2) +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        date.getFullYear();
    return stringDate;
}

function toLocalNetString(date) {
    const stringDate = (date.getFullYear() + "-" + ("0" + (date.getMonth() + 1)).slice(-2)) +
        "-" +
        ("0" + date.getDate()).slice(-2) +
        "T" +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2) +
        ":" +
        ("0" + date.getSeconds()).slice(-2);
    return stringDate;
}

function base64toBlob(base64Data, contentType) {
    contentType = contentType || '';
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        let begin = sliceIndex * sliceSize;
        let end = Math.min(begin + sliceSize, bytesLength);

        let bytes = new Array(end - begin);
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
}

function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : ((r & 0x3) | 0x8);
        return v.toString(16);
    });
}


function toArray(data) {
    return (data ? (Array.isArray(data) ? data : [data]) : [])
}

function toNewArray(data) {
    return (data ? (Array.isArray(data) ? [...data] : [data]) : [])
}

function intToStringWithPadZero(num, size) {
    let numStr = num.toString();
    if (size <= num.length) return numStr;

    return ("0000000000000000" + num).substr(-size);
}


function intToStringWithPadZeroHex(num, size) {
    let numStr = num.toString();
    if (size <= num.length) return numStr;

    return ("0000000000000000" + num.toString(16)).substr(-(size * 2));
}